import React from "react";
import styled from 'styled-components';
import Slider from "react-slick";
// import imgOne from "../../img/newsEvent.jpg";

import admissionFree from "../../img/admissionFree.png";
import Ue from "../../img/ue.png";
import Sita from "../../img/sita.png";
import imgOne from "../../img/hp_1.png";
import imgThree from "../../img/hp_3.png";
import imgTwo from "../../img/hp_2.png";
import imgFor from "../../img/hp_4.png";
import imgFive from "../../img/hp_5.png";
import imgSix from "../../img/hp_6.png";


const Scope =styled.div`
text-align: -webkit-center;
`
export default function SimpleSlider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    autoplay:true,
  };
  
  // 2026年1月16日 13:00:00以降にadmissionFreeを表示する設定
  const targetDate = new Date(2026, 0, 16, 13, 0, 0);
  const currentDate = new Date();

  const images = [Ue,Sita, imgOne, imgTwo, imgThree, imgFor, imgFive];

  if (currentDate >= targetDate) {
    // images.unshift(admissionFree);
  }

  return (
    <Slider {...settings}>
      {images.map((src: string, index: number)=>
        <Scope >
          {index == 1 &&
            <img style={{width:'80%',height:'auto'}} src={src} key={`${index}`} alt="pictuer" />    
          }          
          {index !== 1 &&
            <img style={{width:'80%',height:'auto'}} src={src} key={`${index}`} alt="pictuer" />    
          }
        </Scope>
      )}
    </Slider>
  );
}
